import { render, staticRenderFns } from "./CommentaireComponent.vue?vue&type=template&id=711282a8"
import script from "./CommentaireComponent.vue?vue&type=script&lang=js"
export * from "./CommentaireComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports